<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gtZH3Q/tc-custom/cover.jpeg?1663929328403?1704425057474" alt="This image is the cover for the book Rocket Summer and two more stories, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rocket Summer and two more stories, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>This is a great collection of action short stories by Ray Bradbury from "The Golden Age of Science Fiction". Featured here: "Rocket Summer", "Jonah of the Jove-Run", and "Pillar of Fire".</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ray Bradbury
      </h2>
      
      <p class="authorDescription body article">Ray Douglas Bradbury (August 22, 1920 – June 5, 2012) was an American author and screenwriter. One of the most celebrated 20th-century American writers, he worked in a variety of modes, including fantasy, science fiction, horror, mystery, and realistic fiction.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1f689304